import './App.scss'
import { Charts } from './components/Charts'
import { Form } from './components/Form'
import { Calculations } from './components/Calculations'

function App() {
  return (
    <div className="App">
      <Charts />
      <Form />
      <Calculations />
    </div>
  )
}

export default App
